<template lang="html">
  <form role="form">

    <EpayInputFormGroup :label="$t('E-mail кошелька')" attribute="wallet_email" :model="model" :required="true" />

    <payout-form-group>
      <h3 style="width: 380px; text-align: center;">{{ $t('Получатель') }}</h3>
    </payout-form-group>
    <EpayInputFormGroup :label="$t('Имя получателя')" attribute="name" :model="model" :required="true" />
    <EpayInputFormGroup :label="$t('Фамилия получателя')" attribute="surname" :model="model" :required="true" />
    <EpayInputFormGroup :label="$t('Номер телефона')" attribute="code,phone" type="phonewitharea" :model="model" :required="true" />
    <EpayInputFormGroup :label="$t('E-mail')" attribute="email" :model="model" :required="true" />

    <payout-form-group>
      <h3 style="width: 380px; text-align: center;">{{ $t('Адрес получателя') }}</h3>
    </payout-form-group>
    <EpayInputFormGroup :label="$t('Страна')"
                        @input="onCountryChange"
                        type="country" countryValueKey="alpha3"
                        attribute="country" :model="model" :required="true" />
    <template v-if="model.values.country == 'USA' || model.values.country == 'CAN'">
    <EpayInputFormGroup :label="$t('Штат')"
                        type="state" :state-country="model.values.country"
                        attribute="state" :model="model" :required="true" />
    </template>
    <EpayInputFormGroup :label="$t('Адрес')" attribute="address" :model="model" :required="true" />
    <EpayInputFormGroup :label="$t('Город')" attribute="city" :model="model" :required="true" />
    <EpayInputFormGroup :label="$t('Почтовый индекс')" attribute="zip" :model="model" :required="true" />

    <hr/>

    <payout-textfield-input-group
      :model="model"
      attribute="description"
      :label="$t('Назначение платежа')"
    ></payout-textfield-input-group>

    <payout-input-amount-form-group :model="model"></payout-input-amount-form-group>
    <payout-estimated-destination-amount-form-group :model="model"></payout-estimated-destination-amount-form-group>

    <payout-destination-currency-conversion-notice-form-group :model="model"></payout-destination-currency-conversion-notice-form-group>
    <payout-evaluate-fee-form-group :model="model"></payout-evaluate-fee-form-group>

    <payout-toggable-hint-panel-form-group :heading="$t('Лимиты')"
                                           :link-text="$t('Информация о лимитах')">
      {{$t('limits_text_1', {
      minAmount: 5, minCurrency: 'EUR',
      maxAmount: 10000, maxCurrency: 'EUR'
    })}}
    </payout-toggable-hint-panel-form-group>

    <payout-form-notification-block :model="model"></payout-form-notification-block>
    <hr>
    <payout-group-verification-type :model="model"></payout-group-verification-type>
  </form>
</template>

<script lang="ts">
import {Component, Watch} from "vue-property-decorator";
import PayoutFormGroup from "@/components/forms/payout/PayoutFormGroup.vue";
import PayoutInputHintBlock from "@/components/forms/payout/PayoutInputHintBlock.vue";
import ErrorMessageBlock from "@/components/forms/payout/ErrorMessageBlock.vue";
import PayoutTextfieldInputGroup from "@/components/forms/payout/PayoutTextfieldInputGroup.vue";
import PayoutToggableHintPanelFormGroup
  from "@/components/forms/payout/hint/PayoutToggableHintPanelFormGroup.vue";
import PayoutGroupVerificationType
  from "@/components/payout/verification/PayoutGroupVerificationType.vue";
import PayoutInputAmountFormGroup from "@/components/forms/payout/PayoutInputAmountFormGroup.vue";
import PayoutEstimatedDestinationAmountFormGroup
  from "@/components/forms/payout/forms/PayoutEstimatedDestinationAmountFormGroup.vue";
import PayoutEvaluateFeeFormGroup from "@/components/forms/payout/PayoutEvaluateFeeFormGroup.vue";
import PayoutFormNotificationBlock
  from "@/components/forms/payout/forms/PayoutFormNotificationBlock.vue";
import AbstractPayoutForm from "@/components/forms/payout/abstract/AbstractPayoutForm.vue";
import FilteredInputWrapper from "@/components/forms/payout/forms/inputs/FilteredInputWrapper.vue";
import PayoutDestinationCurrencyConversionNoticeFormGroup
  from "@/components/forms/payout/crypto/PayoutDestinationCurrencyConversionNoticeFormGroup.vue";
import {SkrillBtcBitPayoutModel} from "capitalist-shared/src/finance/payout/btcbit/btcbit";
import EpayInputFormGroup from "@/components/forms/payout/forms/epay/EpayInputFormGroup.vue";



@Component({
  name: "SkrillPaymentForm",
  components: {
    EpayInputFormGroup,
    PayoutDestinationCurrencyConversionNoticeFormGroup,
    FilteredInputWrapper,
    PayoutFormNotificationBlock,
    PayoutEvaluateFeeFormGroup,
    PayoutEstimatedDestinationAmountFormGroup,
    PayoutInputAmountFormGroup,
    PayoutGroupVerificationType,
    PayoutToggableHintPanelFormGroup,
    PayoutTextfieldInputGroup,
    ErrorMessageBlock,
    PayoutInputHintBlock,
    PayoutFormGroup
  }
})
export default class SkrillPaymentForm extends AbstractPayoutForm {

  onCountryChange() {
    // Reset state when country changes
    this.model.values.state = '';
  }

  model: SkrillBtcBitPayoutModel = new SkrillBtcBitPayoutModel();


}
</script>

<style scoped>

</style>

<i18n>
{
  "en": {
    "Назначение платежа": "Description",
    "E-mail кошелька": "Wallet e-mail",
    "Получатель": "Recipient",
    "Имя получателя": "Recipient's first name",
    "Фамилия получателя": "Recipient's last name",
    "Номер телефона": "Phone number",
    "E-mail": "E-mail",
    "Адрес получателя": "Recipient's address",
    "Страна": "Country",
    "Адрес": "Address",
    "Город": "City",
    "Почтовый индекс": "Postal code",
    "neteller": {
      "destinationHint": "Account number: digits."
    },
    "limits_text_1": "Minimum one-time payment: {minAmount} {minCurrency}, maximum: {maxAmount} {maxCurrency}.",
    "Лимиты": "Limits",
    "Информация о лимитах": "Limits",
    "Штат": "State"
  },
  "ru": {
    "limits_text_1": "Минимальный разовый платеж: {minAmount} {minCurrency}, максимальный: {maxAmount} {maxCurrency}.",
    "E-mail кошелька": "E-mail кошелька",
    "Получатель": "Получатель",
    "Имя получателя": "Имя получателя",
    "Фамилия получателя": "Фамилия получателя",
    "Номер телефона": "Номер телефона",
    "E-mail": "E-mail",
    "Адрес получателя": "Адрес получателя",
    "Страна": "Страна",
    "Адрес": "Адрес",
    "Город": "Город",
    "Почтовый индекс": "Почтовый индекс"
  }
}
</i18n>
